import React from 'react';

import classes from './AssignmentViewCard.module.css';
import { IsListEmpty } from '../../../utilities/CommonMethods';
import { cleanHTML } from '../../../utilities/CommonMethods';
import CloseIcon from "../../../assets/icons/icon-close-black.png";


const AssignmentViewCard = (props) => {
    const gradingObjectivesList = !IsListEmpty(props.assignment.gradingGuidesList) ? props.assignment.gradingGuidesList.map((objective, index) => {
        return (
            <tr key={index}>
                <td className={classes.AlignLeft}>{objective.value}</td>
                <td className={classes.Normal}>{objective.maxScore}</td>
            </tr>
        );
    }) : null;

    const onProblemClose = () => {
        props.onCloseProblem(props.pos);
    }
    return (
        <div className={classes.AssignmentViewCard}>
            <div className={classes.HeadingSection}>
                <div className={classes.HeadingContainer}>
                    <h5 className={classes.ProblemName}>{props.assignment.name}</h5>
                    <p className={classes.MaxScore}>Max Score: {props.assignment.score}</p>
                    <p className={classes.Level}>Dificulty Level: {props.assignment.level}</p>
                </div>
                <p className={classes.TextLink} onClick={() => onProblemClose()}><img src={CloseIcon} alt="Close" /></p>
            </div>

            <hr className={classes.Divider} />

            <div>
                <pre
                    className={[classes.ProblemDescription].join(' ')}
                    dangerouslySetInnerHTML={{ __html: cleanHTML(props.assignment.description) }}></pre>
            </div>

            <hr className={classes.Divider} />

            <div>
                <p className={classes.ResultText}>Grading Guide</p>

                <table className={classes.Table}>
                    <thead className={classes.TableHeadings}>
                        <tr>
                            <th className={classes.Objective}>OBJECTIVE</th>
                            <th className={classes.Marks}>TOTAL MARKS</th>
                        </tr>
                    </thead>
                    <tbody className={classes.TableBody}>

                        {gradingObjectivesList}

                        <tr className={classes.ResultRow}>
                            <td className={classes.AlignLeft}>Total</td>
                            <td>{props.assignment.score}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div >
    );
}

export default AssignmentViewCard;